import { QuestionFragment } from "@gql-schema";
import { Faqs } from "@ui/components/faqs/faqs";
import { useTranslation } from "next-i18next";
import React, { FC } from "react";

interface Props {
    items: QuestionFragment[];
}

export const FaqPageSection: FC<Props> = ({ items }) => {
    const { t } = useTranslation();

    return (
        <div className="bg-uxfVioletLightest">
            <div className="ui-container space-y-20 pb-20">
                <div className="flex flex-col items-center pt-8 md:pt-16">
                    <p className="ui-typo-overline-large opacity-60">{t("faq")}</p>
                    <h1 className="ui-typo-h1 mt-8 text-center">{t("faq.title")}</h1>
                </div>
                <Faqs isLink items={items} />
            </div>
        </div>
    );
};
